export default {
	state: () => ({
		data: {
			activeMember: null,
		}
	}),
	mutations: {
		['team/setState'](state, payload) {
			state.data = {
				...payload,
				activeMember: state.data.activeMember,
			};
		},
		['team/setActiveMember'](state, payload) {
			state.data = {
				...state.data,
				activeMember: payload,
			};
		}
	}
}